import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import Parallax from "@/components/Parallax";
import { DotWaterhole } from "@/components/AboriginalPatterns";

const CoreQuestionSection = () => (
  <>
    {/* Core Question */}
    <section className="relative section-padding bg-card/80 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-tl from-ochre/[0.02] via-transparent to-transparent" />
      <Parallax className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" offset={-30}>
        <DotWaterhole className="text-primary opacity-[0.05]" size={700} />
      </Parallax>
      <div className="relative max-w-3xl mx-auto px-6">
        <FadeIn>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-8 tracking-tight">
            Where Are the Weak Points<br />
            <span className="text-gradient">Quietly Forming?</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="space-y-6 text-muted-foreground leading-relaxed text-lg">
            <p>If most acquisitions underperform...</p>
            <p>If most strategy failure is execution failure...</p>
            <p className="text-foreground font-medium">
              Then the rational question is not whether the strategy is compelling.
            </p>
            <p>
              It is whether the people responsible for executing it can <span className="text-foreground font-medium">hold up under real pressure</span>.
            </p>
            <p>
              Boomerang Cultures exists to answer that question before you close.
            </p>
            <div className="pl-4 border-l-2 border-primary/20 space-y-2 text-foreground/70 font-medium">
              <p>Before due diligence reveals it.</p>
              <p>Before integration exposes it.</p>
              <p>Before scrutiny forces defensive action.</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>

    {/* Final CTA */}
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-primary/[0.03] via-transparent to-transparent" />
      <Parallax className="absolute -bottom-48 -right-40" offset={60} offsetX={20}>
        <DotWaterhole className="text-ochre opacity-[0.04]" size={650} />
      </Parallax>
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <FadeIn>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-4 max-w-2xl mx-auto">
            Whether you are evaluating a target, closing a deal, or integrating an acquisition,
            and you want an independent, disciplined examination of execution durability:
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-12 tracking-tight">
            Start the conversation.
          </p>
        </FadeIn>
        <FadeIn delay={0.15}>
          <Link
            to="/book-a-call"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold uppercase tracking-wider bg-primary text-primary-foreground hover:bg-warmglow smooth rounded-full group hover:shadow-lg hover:shadow-primary/20 hover:-translate-y-px"
          >
            Request a Confidential Discussion
            <ArrowRight size={15} className="group-hover:translate-x-1 smooth" />
          </Link>
        </FadeIn>
      </div>
    </section>
  </>
);

export default CoreQuestionSection;
